import { Props } from './types'
import { Tooltip, Typography } from '@frontend/design_system'
import { MAX_STRING_LENGTH } from './constants'
import styles from './styles.module.scss'

export const TableTooltip = ({
  title,
  tooltip,
  onClick,
  tooltipThreshold = MAX_STRING_LENGTH,
}: Props) => {
  const lengthString = title.trim().length

  if (lengthString < tooltipThreshold) {
    return (
      <div className={styles['tooltip-wrapper']}>
        <Typography
          name="Subtitle7"
          onClick={onClick ? onClick : undefined}
          className={styles['tooltip-content']}
        >
          {title}
        </Typography>
      </div>
    )
  }

  return (
    <Tooltip
      popupContent={tooltip || title}
      placement="top"
      size="secondary"
      isFullWidthContent
    >
      <Typography
        name="Subtitle7"
        className={styles['tooltip-content']}
        onClick={onClick ? onClick : undefined}
      >
        {title}
      </Typography>
    </Tooltip>
  )
}
